// Utility function for smooth scrolling with navbar offset
export const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; // Adjust this value based on your navbar height
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};

export const scrollWithOffsetLarge = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -100; // Adjust this value based on your navbar height
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};

export const scrollWithOffsetSmall = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -50; // Smaller offset for specific cases
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};